import React from 'react';

const Shop = ({ articlecategories }) => {
    return null;
}

export default Shop;
